import { theme } from "utils/Theme/theme";

export const wrapper = {
    backgroundColor: theme.palette.grey[50],
};

export const textContent = {
    fontSize: "15px",
};
